import React from "react";
import "../styles/sections.css"; // Import the CSS file for the hero section

const Hero = ({ translations }) => {
  return (
    <section id="hero" className="section hero gradient-background">
      <div className="container">
        <h2>{translations.heroTitle}</h2>
        <p className="hero-description">{translations.heroDescription}</p>
        <p className="hero-subtitle">{translations.heroSubtitle}</p>
        <a href="https://chromewebstore.google.com/detail/v-assistant/dbnkcofhncegnjcnngabfgfhgkbkmboh" 
          target="_blank" 
          rel="noopener noreferrer">
          <button className="button">{translations.heroButton}</button>
        </a>
      </div>
    </section>
  );
};

export default Hero;